var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-vue",style:(_vm.bg)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v("WELCOME")])])
}]

export { render, staticRenderFns }